import * as React from 'react';
import { IComponentController } from '@wix/editor-elements-types';

const mapActionsToProps: IComponentController = ({ updateProps }) => ({
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
    updateProps({
      value: event.target.value,
    });
  },
  setValidityIndication: (shouldShowValidityIndication: boolean) => {
    updateProps({
      shouldShowValidityIndication,
    });
  },
  setValue: (value: string) => {
    updateProps({
      value,
    });
  },
});

export default mapActionsToProps;
